export const moveSvg = `<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 7H14M7.5 0.5V13.5M5.5 2.5L7.5 0.5L9.5 2.5M5.5 11.5L7.5 13.5L9.5 11.5M12 5L14 7L12 9M3 5L1 7L3 9" stroke="#42526E" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
